export default __webpack_public_path__ + "static/media/CARD PDF.c0a15fef.pdf";